import angular from 'angular';

import { leadPopupRoutesConfig } from './lead.popup.routes';

export default angular.module('lead.popup', []).config(leadPopupRoutesConfig);
